import React, { useEffect, useState } from "react";
import { useHistory } from "routerCompat";
import { getServiceHisotryDetail } from "../../../Services/emergency";
import Header from "../../header";
import Spinner from "../../Spinner/Spinner";
import LocationMap from "../newService/Map";

const HistoryItemDetail = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [showMap, setShowMap] = useState(false);
  const history = useHistory();

  useEffect(() => {
    let id = history.location.search.split("");
    id.splice(0, 1);
    id = id.join("");
    getServiceHisotryDetail(id).then((res) => {
      setData(res.data.data);
      setLoading(false);
    });
  }, []);
  const handleShowmap = (condition) => {
    setShowMap(condition);
  };
  const location = {
    mapDetails: {
      lng: data?.longitude,
      lat: data?.latitude,
    },
  };
  return showMap ? (
    <LocationMap handleShowmap={() => handleShowmap()} location={location} />
  ) : loading ? (
    <Spinner />
  ) : (
    <>
      <Header showSearchBar={true} title="جزئیات درخواست" />
      <div className="historyDetailWrapper">
        <div className="detailRecipt">
          <span>{data.car}</span>
          <span>{data.date}</span>
        </div>
        <div className="detailServicesWrapper">
          {data.extras
            ? data.extras.map((item, q) => (
                <div className="detailExtras">
                  <span>{item.title}</span>
                  <span>{item.garage_price} تومان</span>
                </div>
              ))
            : null}
          {data.services
            ? data.services.map((item, q) => (
                <div className="detailServices">
                  <span>{item.title}</span>
                  <span>{item.garage_price}تومان</span>
                </div>
              ))
            : null}
        </div>
        <div className="detailLocation">
          <span>محل ارائه خدمات :</span>
          <span>{data.address}</span>
        </div>
        <div className="detailGarage">
          <div>
            <span>مشخصات تعمیرکار</span>
            <span>{data.garage.name}</span>
          </div>
          <div>
            <span>شماره تماس تعمیرکار</span>
            <span>{data.garage.phone}</span>
          </div>
        </div>
        <div className="detailTotalPrice">
          <span>مبلغ کل:</span>
          <span>{data.price} تومان</span>
        </div>
        <div
          className="DetailMap"
          onClick={() => {
            handleShowmap(true);
          }}
        >
          <img src="/public/assets/map.jpg" className="Mapbody" alt="map" />
          <img
            src="/public/assets/icons/locationInMap.svg"
            className="LocationMap"
            alt="location"
          />
          <span>مشاهده موقعیت مکانی روی نقشه</span>
        </div>
      </div>
    </>
  );
};

export default HistoryItemDetail;
